import { Tag } from '../../types/shared';

import { TagTypes } from '../../tokens';

const getUniqueTags = (tags: Tag[]): Tag[] => [
  ...new Map(tags.map((tag) => [tag.id, tag])).values(),
];

const getMainTags = (tags: Tag[]): Tag[] =>
  tags.filter(
    (tag) =>
      ![TagTypes.SEGMENT, TagTypes.TOPIC].some((type) => type === tag.type)
  );

const getSubTags = (tags: Tag[]): Tag[] =>
  tags.filter((tag) => [TagTypes.TOPIC].some((type) => type === tag.type));

const getTagsByTypes = (tags: Tag[], types: TagTypes[]): Tag[] =>
  tags.filter((tag) => types.includes(tag.type as TagTypes));

const sortTagsAlphabetically = (tags: Tag[]): Tag[] =>
  tags.sort((currentTag, previousTag) =>
    currentTag.name.localeCompare(previousTag.name)
  );

export {
  getMainTags,
  getSubTags,
  getTagsByTypes,
  getUniqueTags,
  sortTagsAlphabetically,
};
